<template>
    <div>
        <!-- Grey logo section -->
        <logo-component v-if="!showPromotionalBanner && !embedded"></logo-component>

        <!-- Welcome banner -->
        <component :is="welcomeBannerComponent" v-if="!embedded"></component>

        <section class="account-form">
            <div class="page-container">
                <div class="heading">
                    <h4 class="heading__h4">{{ heading }}</h4>
                    <p>To get started, please enter a valid Ulta Beauty Rewards<sup>&reg;</sup> Mastercard<sup>&reg;</sup> Credit Card number to create <br> your account.</p>
                </div>
                <div v-if="errors.length">
                    <b>Please correct the following error(s):</b>
                    <ul style="color: red">
                        <li  class="alert alert-danger"  v-for="error in errors">{{ error }}</li>
                    </ul>
                </div>
                <form method="POST" action="user/register">
                    <div class="form-container">
                        <div class="clear">
                            <div class="form-element float-left" :class="{ 'error': errors.name }">
                                <label for="name" class="title">First Name</label>
                                <input id="name" type="text" v-model="firstName" required autofocus>

                                <!-- <div v-if="errors[0]" class="error-message">{{ errors[0] }}</div> -->
                            </div>
                            <div class="form-element float-right">
                                <label for="last-name" class="title">Last Name</label>
                                <input id="last-name" type="text" v-model="lastName" required autofocus>
                                <!-- <div v-if="errors[1]" class="error-message">{{ errors[1] }}</div> -->
                            </div>
                        </div>
                        <div class="clear">
                            <div class="form-element float-left">
                                <label for="email" class="title">E-Mail Address</label>
                                <input id="email" type="email" v-model="email" required>
                            </div>
                            <div class="form-element float-right">
                                <label for="name" class="title">Zip Code</label>
                                <input id="postal-code" type="text" v-model="postal_code" required autofocus maxlength="5" @input="postal_code = postal_code.replace(/[^0-9]/g, '')">
                            </div>
                        </div>
                        <div class="clear">
                            <div class="form-element float-left">
                                <label for="password" class="title">Password</label>
                                <input id="password" type="password" v-model="password" required>
                                <span>Must be between 8-14 characters in length, as well as include an uppercase &amp; lowercase letter, number, and special character.</span>
                            </div>
                            <div class="form-element float-right">
                                <label for="password-confirm" class="title">Confirm Password</label>
                                <input id="password-confirm" type="password" v-model="password_confirmation" required>
                            </div>
                        </div>
                        <div class="clear">
                            <div class="form-element float-left">
                                <label for="card-num" class="title">Ulta Beauty Rewards<sup>&reg;</sup> Mastercard<sup>&reg;</sup> Credit Card number</label>
                                <input id="card-num" type="text" v-model="card_no" required autofocus maxlength="19" @input="handleCardInput">
                                <span class="flex-wrapper flex-wrap"><i class="icon-lock"></i>Secure transmission</span>
                            </div>
                        </div>
                        <div class="clear">
                            <div class="form-element">
                                <input id="terms_conditions" type="checkbox" name="terms_conditions" v-model="termsConditions"
                                class="styled-checkbox" :class="{ 'error': errors.termsConditions }">
                                <label for="terms_conditions" class="">By checking this box and entering my payment card information, I authorize my Payment Card Network (Mastercard<sup>&reg;</sup>) to monitor and share transaction data associated with my registered payment card (including spending history) with Ulta Beauty Rewards and its third party service providers in accordance with the Program Terms &amp; Conditions and Privacy Policy.</label>
                                <div v-if="errors.termsConditions" class="error-message">{{ errors.termsConditions }}</div>
                            </div>
                            <div class="form-element">
                                <input id="email_optin" type="checkbox" name="email_optin" v-model="emailOptin" class="styled-checkbox">
                                <label for="email_optin" class="">Yes, please send me email offers &amp; promotions.</label>
                            </div>
                            <div class="form-element" v-if="siteKey">
                                <vue-recaptcha
                                    :sitekey="siteKey"
                                    @verify="onCaptchaVerify"
                                    ref="recaptcha"
                                />
                                <span
                                    v-if="recaptcha_error"
                                    class="error-message"
                                >
                                Please confirm you are not a robot.
                            </span>
                            </div>
                                <span v-if="errors.length" class="alert alert-danger">Please correct the errors above.</span>
                        </div>
                        <div class="button-container flex-wrapper flex-wrap">
                            <button type="submit" :disabled="loading" class="button pink large wide" @click="handleSubmit">{{this.loading ? 'Please wait' : submitLabel}}</button>
                        </div>

                    </div>
                </form>
                <!-- <create-account></create-account> -->
            </div>
        </section>
        <footer-component v-if="!embedded">
            <template v-slot:after-links v-if="showPromotionalBanner">
                <pre-login-disclosure />
            </template>
        </footer-component>
    </div>
</template>

<script>
    //import CreateAccount from './CreateAccount.vue';
    import { VueRecaptcha } from 'vue-recaptcha';
    import FooterComponent from './FooterComponent.vue';
    import WelcomeBannerPromotionComponent from './banners/WelcomeBannerPromotionComponent.vue';
    import WelcomeBannerComponent from './banners/WelcomeBannerComponent.vue';
    import PreLoginDisclosure from "./promotions/PreLoginDisclosure.vue";

    export default {
        components: {PreLoginDisclosure, VueRecaptcha, WelcomeBannerComponent, WelcomeBannerPromotionComponent,FooterComponent},
        name: "RegisterComponent",

        // When `embedded` is true (e.g. inside the campaign modal) the page chrome
        // is hidden and, on success, a `registered` event is emitted instead of
        // redirecting to /offers so the host can decide what happens next.
        props: {
            embedded: {
                type: Boolean,
                default: false
            },
            heading: {
                type: String,
                default: 'Create account'
            },
            submitLabel: {
                type: String,
                default: 'Submit'
            }
        },

        data(){
            return {
                errors: [],
                firstName : "",
                lastName: "",
                email : "",
                password : "",
                postal_code:"",
                card_no:"",
                password_confirmation : "",
                termsConditions: false,
                emailOptin: true,
                siteKey: ENV_RECAPTCHAV2_SITEKEY,
                g_recaptcha_response: null,
                recaptcha_error: false,
                loading: false,
                showPromotionalBanner: window.appGlobalData.showPromotionalBanner,
                welcomeBannerComponent : window.appGlobalData.showPromotionalBanner?WelcomeBannerPromotionComponent:WelcomeBannerComponent
            }
        },
        methods : {
            handleCardInput(event) {
                // Allow only numbers and hyphens
                this.card_no = this.card_no.replace(/[^0-9-]/g, '');
            },
            validate() {

                this.errors = [];

                if (this.firstName === '') {
                    this.errors.push('First name is required.');
                }
                if (this.lastName === '') {
                    this.errors.push('Last name is required.');
                }
                if (isNaN(this.postal_code) || this.postal_code === '') {
                    this.errors.push('Postal Code is required.');
                }

                if (isNaN(this.card_no) || this.card_no === '') {
                    this.errors.push('Card Number is required.');
                }

                if(!this.validateEmailInput(this.email)) {
                    this.errors.push("Valid email required.");
                }

                if (this.password === this.password_confirmation && this.password.length > 0) {

                } else {
                    this.errors.push("Passwords do not match.");
                }

                if (this.emailOptin != true) {
                    // this.errors.push('terms and conditions consent is required.');
                }

                if (this.termsConditions != true) {
                     this.errors.push('Terms and conditions consent is required.');
                }

                return this.errors.length == 0;
            },
            validateRecaptcha() {

                if(!this.g_recaptcha_response) {
                    this.recaptcha_error = true;

                    // return false;
                }

                return true;
            },

              onCaptchaVerify(token) {
                  // Provide the token response to the form object.
                  this.g_recaptcha_response = token;
              },

            // Reset the widget only if it's actually rendered (it isn't when no
            // sitekey is configured, e.g. local dev with reCAPTCHA disabled).
            resetCaptcha() {
                if (this.$refs.recaptcha) {
                    this.$refs.recaptcha.reset();
                }
                this.g_recaptcha_response = null;
            },

            handleSubmit(e) {

                e.preventDefault();

                // Let the host clear any previous notice (e.g. the "account exists"
                // message) at the start of every attempt.
                if (this.embedded) {
                    this.$emit('submit-start');
                }

                if (this.validate() && this.validateRecaptcha()) {
                    this.loading = true;
                    axios.post(this.apiEndPoints.registerUser, {
                        first_name: this.firstName,
                        last_name: this.lastName,
                        email: this.email,
                        password: this.password,
                        password_confirmation : this.password_confirmation,
                        postal_code: this.postal_code,
                        card_no: this.card_no,
                        g_recaptcha_response: this.g_recaptcha_response,
                        termsConditions: this.termsConditions,
                        emailOptin: this.emailOptin
                    })
                        .then(response => {
                            // console.log(response);

                            if(response.data && response.data.status) {

                                if(response.data.status == 'success') {
                                    if (this.embedded) {
                                        this.$emit('registered');
                                    } else {
                                        this.$router.push({name : 'offers'});
                                    }

                                } else if (this.embedded && response.data.code === 'email_exists') {
                                    // Host (campaign modal) shows the message as a header
                                    // notice and prefills the sign-in email.
                                    this.resetCaptcha();
                                    this.$emit('email-exists', this.email, response.data.message);
                                } else if(response.data.message) {
                                    this.resetCaptcha();
                                    this.errors.push(response.data.message);
                                } else {
                                    this.resetCaptcha();
                                    this.errors.push('An error occurred. Please try again!');
                                }
                            }
                        })
                        .catch(error => {
                            this.resetCaptcha();
                            console.error(error.response);
                            if(error.response.data.message) {
                                this.errors.push(error.response.data.message);
                            } else {
                                this.errors.push('An error occurred. Please try again!');
                            }

                        }).finally(() => {
                             this.loading = false;
                    });
                } else {
                     this.resetCaptcha();
                }
            }
        }
    }
</script>

<style scoped>

</style>
